<template>
	<div class="contenedor">
		<login v-if="!login" :on-login="onLogin"></login>
		<menu-principal v-if="login && menu == ''" :on-menu="onMenu"></menu-principal>
		<face-header v-if="login && menu != ''" :menu="menu" :on-menu="onMenu" :on-login="onLogin"></face-header>
		<desktop v-if="login && menu != ''" :menu="menu"></desktop>
		<div v-if="cargando" id="cargando" class="row text-center align-items-center">
			<div class="col-md-12">
				<img src="/images/cargando.gif" class="loader" /></div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import Vue from "vue"
	import axios from "axios"
	import Login from "./login.vue"
	import MenuPrincipal from "./menu-principal.vue"
	import FaceHeader from "./header.vue"
	import Desktop from "./desktop.vue"
	import Config from "./config.json"


	export default 
	{
		name: "Face",    
		components: { Login, MenuPrincipal, FaceHeader, Desktop },
		data() {
			return {
				login: false,
				menu: "",
				cargando: false,
			}
		},      
		created() {

			const now = new Date()
			const anio = now.getFullYear()
			const mes = (now.getMonth() +1) < 10 ? "0" + (now.getMonth() +1) : (now.getMonth() +1)
			const dia = now.getDate()

			// Variable global para guardar el periodo de consulta (YYYY-MM-DD)
			Vue.prototype.$periodo = anio + "-" + mes + "-" + dia

			// Variables globales para usar en las llamadas a la api
			Vue.prototype.$env = Config.env
			Vue.prototype.$api = Config.url[Config.env]

			// Parametros globales para la llamada a las apis
			axios.defaults.headers.common["Content-Type"] = "application/json"
			axios.defaults.baseURL = this.$api
		},
		mounted: function() {

			var that = this
			window.event.$on("mostrar-cargando", function(mostrar) {

				that.cargando = mostrar
			})
		},
		methods: {

			// Funcion callback que captura el evento de login o cerrar sesion
			onLogin(login) {

				this.login = login
				this.menu = ""
			},

			// Funcion callback que captura el evento click de los botones del menu
			onMenu(menu) {

				// Actualizamos la variable menu
				this.menu = menu

				window.event.$emit("evento-cambia-titulo", this.menu)
			},
		}
	}
</script>
<style scoped>

	.contenedor {
		position: absolute;
		min-height: 100%;
		width: 100%;
		height: 100%;
	}

	#cargando {
		position: absolute;
		top: 0;
		width: Calc(100% - 100px);
		height: Calc(100% - 100px);
		text-align: center; 
		background-color: white;
		margin: 50px !important;
		z-index: 9999;
		/*border: 2px solid black;*/
		border-radius: 8px; 
		box-shadow: 5px 5px 3px 0 rgb(0 0 0 / 30%);
	}   

	.loader {
		width: 120px;
	}

</style>
